export default {
  catalog: {
    en: 'Catalog',
  },
  main: {
    en: 'Main',
  },
  men: {
    en: 'Men',
  },
  women: {
    en: 'Women',
  },

  menMainPage: {
    en: 'Men main page',
  },
  womenMainPage: {
    en: 'Women main page',
  },

  fineFragrance: {
    en: 'Fine fragrance',
  },
  perfumes: {
    en: 'Perfumes',
  },
  colognes: {
    en: 'Colognes',
  },
  recommendations: {
    en: 'Recommendations',
  },
  fragranceByState: {
    en: 'Fragrance by state',
  },
  collectionsWomen: {
    en: 'Collections for women',
  },
  collectionsMen: {
    en: 'Collections for men',
  },
  perfumeOfTheMonth: {
    en: 'Perfume of the month',
  },
  cologneOfTheMonth: {
    en: 'Cologne of the month',
  },
  extras: {
    en: 'Extras & Cases',
  },

  fragranceHoroscope: {
    en: 'Fragrance horoscope',
  },
  horoscope: {
    aries: {
      en: 'Aries',
    },
    taurus: {
      en: 'Taurus',
    },
    gemini: {
      en: 'Gemini',
    },
    cancer: {
      en: 'Cancer',
    },
    leo: {
      en: 'Leo',
    },
    virgo: {
      en: 'Virgo',
    },
    libra: {
      en: 'Libra',
    },
    scorpio: {
      en: 'Scorpio',
    },
    sagittarius: {
      en: 'Sagittarius',
    },
    capricorn: {
      en: 'Capricorn',
    },
    aquarius: {
      en: 'Aquarius',
    },
    pisces: {
      en: 'Pisces',
    },
  },

  fragranceFinder: {
    en: 'Fragrance finder',
  },

  skincare: {
    en: 'Skincare',
  },
  allSkincare: {
    en: 'All skincare',
  },
  bodyLip: {
    en: 'Lip',
  },

  cleansers: {
    en: 'Cleansers',
  },
  masks: {
    en: 'Masks',
  },
  moisturizers: {
    en: 'Moisturizers',
  },
  treatments: {
    en: 'Treatments',
  },
  mens: {
    en: 'Men\'s',
  },
  wellness: {
    en: 'Wellness',
  },

  candles: {
    en: 'Candles',
  },
  scentedCandles: {
    en: 'Scented candles',
  },

  allMakeup: {
    en: 'All makeup',
  },

  makeup: {
    en: 'Makeup',
  },
  palettes: {
    en: 'Makeup Palettes',
  },
  eye: {
    en: 'Eye',
  },
  lip: {
    en: 'Lip',
  },
  face: {
    en: 'Face',
  },
  cheek: {
    en: 'Cheek',
  },
  tools: {
    en: 'Tools',
  },

  personalCare: {
    en: 'Personal Care',
  },
  allPersonalCare: {
    en: 'All Personal Care',
  },
  bodyMoisturizers: {
    en: 'Body Moisturizers',
  },
  handCreams: {
    en: 'Hand Cream',
  },
  shower: {
    en: 'Shower',
  },

  fathersDay: {
    en: 'Bamboo charcoal',
  },

  gifts: {
    en: 'Gifts',
  },
  allGifts: {
    en: 'All gifts',
  },
  giftCard: {
    en: 'Gift card',
  },
  giftSetsMen: {
    en: 'Gifts For Him',
  },
  giftSetsWomen: {
    en: 'Gifts For Her',
  },
  skincareSets: {
    en: 'Scentbird Gift Sets',
  },
  giftSubscription: {
    en: 'Gift subscription',
  },

  resubscribe: {
    en: 'Resubscribe',
  },
  sendGift: {
    en: 'Send a Gift',
  },
  subscriptionStatus: {
    en: 'Subscription status',
  },
  upgrade: {
    en: 'Upgrade',
  },
  upgradeYourPlan: {
    en: 'Upgrade your plan',
  },
  unpause: {
    en: 'Unpause',
  },
  inviteFriends: {
    en: 'Invite friends',
  },
  retakeQuiz: {
    en: 'Retake quiz',
  },
  help: {
    en: 'Help',
  },
  logout: {
    en: 'Logout',
  },
  earnFreeFragrance: {
    en: 'Earn free fragrance',
  },
  rateNeonHeatKit: {
    en: `
      <div class="title">Rate neon heat kit</div>
      Take a short survey
    `,
  },
  tracking: {
    en: 'Tracking',
  },
  myQueue: {
    en: 'My queue',
  },
  collectionsForWomen: {
    en: 'Collections for women',
  },
  collectionsForMen: {
    en: 'Collections for men',
  },
  whatIsNew: {
    en: 'What’s new',
  },
  reasonsToResubscribe: {
    en: `
      <div class="title">Scentbird</div>
      6 reasons to resubscribe
    `,
  },
  seeAll: {
    en: 'See all',
  },
}
